<script>
    import { onMount, tick } from "svelte";
    import Chart from 'chart.js/auto';
    import Gradient from "../../../services/gradient.js";
    import { createEventDispatcher } from "svelte";
    import { format } from "svelte-i18n";

    const dispatch = createEventDispatcher();


    let { findingCount = {}, handleAdvancedSearch = (x)=>x, advancedSearchFilter} = $props();

    let canvas = $state();
    let chart;
    let totals = $derived(findingCount);
    let total_count = $derived.by(()=>getTotalCount(findingCount));
    let gradientArray = $derived.by(()=>getColorsArray(total_count));


    let kinds = [
        "domain",
        "hostname",
        "public_network",
        "private_network",
        "public_ip",
        "private_ip",
        "ad",
        "cloud",
        "software",
        "endpoint",
        "email",
    ]
    let labels = {
        "domain": $format("asset.kind.domain.plural"),
        "hostname": "Hostnames",
        "public_network": $format("asset.kind.public_network.plural"),
        "private_network": $format("asset.kind.private_network.plural"),
        "public_ip": $format("asset.kind.public_ip.plural"),
        "private_ip": $format("asset.kind.private_ip.plural"),
        "ad": $format("asset.kind.ad.plural"),
        "cloud": $format("asset.kind.cloud.plural"),
        "software": $format("asset.kind.software.plural"),
        "endpoint": $format("asset.kind.endpoint.plural"),
        "email": "Emails",
    };

    const getTotalCount = (count) => {
        //sorry not sorry
        let the_final_countdown = 0
        for(let [key, value] of Object.entries(count)){
            if(value > 0) the_final_countdown++;
        }
        return the_final_countdown;
    }

    const getColorsArray = (count) => {
        let colors = new Gradient()
            //.setColorGradient("#B10c52", "#230B0C")
            .setColorGradient("#343a40","#3c8dbc") // opcion 1
            .setMidpoint(((count <= 2) ? 2 : count))
            .getColors();
        ;
        for(let [index, color] of colors.entries()){
            colors[index] = color + "AE";
        }
        return colors;
    }

    onMount(async () => {
        await tick();

        let context  = canvas.getContext('2d');

        let chartData = {
            labels   : [],
            datasets : {
                backgroundColor : /*count == 10 ?*/ gradientArray, //: colors,
                data: [],
            },
        }

        for (const s of kinds) {
            totals[s] = findingCount[s];
        }

        for (const [k, v] of Object.entries(totals)) {
            if(totals[k] > 0){
                chartData.labels.push(labels[k]);
                chartData.datasets.data.push(v);
            }
        }

        chart   = new Chart(context, {
            type: 'doughnut',
            options: {
                // Elements options apply to all of the options unless overridden in a dataset
                // In this case, we are setting the border of each horizontal bar to be 2px wide

                //clip: false,
                responsive: true,
                maintainAspectRatio: false,
                borderWidth     : 1,
                aspectRatio: 1,
                //cutout: '50%',
                weight : 20,
                plugins:{
                    legend: {
                        position: 'bottom',
                        labels: {
                            font: {
                                fontFamily: 'Montserrat',
                                size: 12
                            }
                        }
                    },
                },
                title: {
                    display: false,
                },
                animation : {
                    animateScale: true,
                    animateRotate: true
                },
                onHover : (event) => {
                    canvas.style.cursor = "pointer";
                },
                onClick: (event)=> {
                    let kind = Object.keys(labels).filter(k=>labels[k] == event.chart.tooltip.title[0])[0];
                    handleAdvancedSearch({detail: {...advancedSearchFilter, asset__kind__in: kind}})
                }
            },
            data : {
                labels  : chartData.labels,
                datasets: [chartData.datasets]
            },
        });
    });
</script>
<style>
    /*#chart-vuls-by-severity {
        height: 250px !important;
        margin: 0 auto;
        width: 808px;
    }*/
</style>
<canvas bind:this={canvas} id="chart-vuls-by-severity" class:chart-has-no-data="{total_count < 1}" ></canvas>
